import { render, staticRenderFns } from "./TraditionalTroubleshooting.vue?vue&type=template&id=c3173e36"
import script from "./TraditionalTroubleshooting.vue?vue&type=script&lang=js"
export * from "./TraditionalTroubleshooting.vue?vue&type=script&lang=js"
import style0 from "./TraditionalTroubleshooting.vue?vue&type=style&index=0&id=c3173e36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports